<template>
  <nav class='language filter-container'>
    <h5>
      <a :href='getPathInLangue("fi")'
         :class='{active : currentLanguage == "fi"}'
         class="nav-button" v-html='"FI"' />
    </h5>
    <span class="separator">/</span>
    <h5>
      <a :href='getPathInLangue("en")'
         :class='{active : currentLanguage == "en"}'
         class="nav-button">
        EN
      </a>
    </h5>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()

// Current language detection
const currentLanguage = computed(() => {
  return route.params.language || 'fi'
})

// Remove invisible pages
const getPathInLangue = function(language){
  return route.path.replace(route.params.language, language);
}
</script>

<style scoped>
.filter-container {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: calc(100% - 0.5rem);
  border-radius: 10rem;
  opacity: 0.8;
  margin: 0;
  padding: 0;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 10rem;
  border-color: var(--dark);
  border-width: var(--border-width);
  border-style: solid;
}

h5 {
  display: inline-block;
  margin: 0;
}

.separator {
  width: 0;
  color: black;
  user-select: none;
}

.nav-button {
  padding: 0.15rem 1.75rem;
  font-weight: 400;
  text-transform: uppercase;
  text-decoration: none;
  color: inherit;
  display: block;
}

.nav-button.active {
  font-weight: 600;
}
</style>
